import { Node, useReactFlow } from "@xyflow/react";
import { useCallback } from "react";

export function useCenterAndZoomOnNode() {
  const { setViewport } = useReactFlow();

  const centerAndZoomOnNode = useCallback(
    (node: Node) => {
      const { position } = node || {};
      const { x, y } = position || {};
      // If selectedNode is defined, x and y should also be defined
      if (x !== undefined && y !== undefined) {
        setViewport(
          {
            x: window.innerWidth / 2 - 460 - x + 130,
            y: window.innerHeight / 2 - y - 160,
            zoom: 1,
          },
          {
            duration: 300,
          },
        );
      }
    },
    [setViewport],
  );

  return { centerAndZoomOnNode };
}
